exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding0-5 > div[data-v-a58add12] {\n  border-radius: 0.4rem;\n  margin-bottom: 0.4rem;\n  background: white;\n}\n.tipInfo[data-v-a58add12] {\n  background: #FFEBEB;\n  color: #FF4040;\n  line-height: 0.9rem;\n  padding: 0.35rem 0.25rem;\n  border-radius: 0.2rem;\n  margin-bottom: 0.4rem;\n}\n.tipInfo img[data-v-a58add12] {\n  width: 0.6rem;\n  margin-top: -0.2rem;\n  margin-right: 0.3rem;\n}\n.margin-5[data-v-a58add12] {\n  margin-top: -0.75rem;\n  z-index: 1;\n}\n.clauseDiv[data-v-a58add12] {\n  width: 100%;\n  bottom: 2.75rem;\n  padding: 0.3rem 0.75rem;\n  background: white;\n  z-index: 99;\n}", ""]);

// exports
